import React, { Component } from 'react';

// Externals
import PropTypes from 'prop-types';

// Material helpers
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next';

// Material components
import Grid from '@material-ui/core/Grid';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

// Shared layouts
import DashboardLayout from 'layouts/Dashboard';

// Custom components
//import Notifications from './components/Notifications';

//import Password from './components/Password';
import ListObjectives from './components/ListObjectives';
import BusinessHours from './components/BusinessHours';
import ClientWeighing from './components/ClientWeighing';
import Apdex from './components/Apdex';
import Flindex from './components/Flindex';
import Tags from './components/Tags';
import { getQueryParams } from '../../utils/fns/get-query-params';
import Flashboard from './Flashboard';
import { FormRegistrosPlus } from './FormRegistrosPlus';
import { isFlindexClientAccess } from '../../hooks/useFlindexClientAccess';

// Component styles
const styles = theme => ({
    root: {
        //Custom Styles AP
        backgroundColor: '#fff'
    }
});

const objectiveConfigProfileAccess = [1, 2, 5]

class ManageObjectives extends Component {
    constructor(props) {
        super(props);
        this.myCallback = this.myCallback.bind(this);
        const queryTab = this.props?.location?.query?.tab ?? 0;
        const activeTab = Number(queryTab) || 0;
        const apdexSetObjectiveId = this.props?.location?.query?.objetivoId;
        const showFlindex = isFlindexClientAccess();
        const initialTab = activeTab === 8 && !showFlindex ? 0 : activeTab;
        this.state = {
            tabIndex: 0,
            props: props,
            value: initialTab,
            profileId: sessionStorage.getItem('profile_id'),
            listHours: [1],
            apdexSetObjectiveId
        }
    }

    myCallback = (dataFromChild) => {
        
        this.setState({
            objectivesList: dataFromChild
        })
    }

    handleChange = (event, newValue) => {
        if (newValue === 8 && !isFlindexClientAccess()) {
            return;
        }
        this.setState({
            value: newValue,
        });
        this.props.history.push({ pathname: "manageObjectives", search: getQueryParams(), query: { tab: newValue } });
    };

    render() {
        const { classes, t } = this.props;
        const {value, objectivesList, profileId, listHours} = this.state;
        var displayHours = false
        var displayWeighing = false
        if(listHours.includes(parseInt(profileId)) === true){
            displayHours = true
            //displayWeighing = true
        }
        const objectiveConfigIsEnabled = objectiveConfigProfileAccess.includes(Number(profileId))
        const showFlindex = isFlindexClientAccess()

        if (!objectiveConfigIsEnabled) {
            return (
                <DashboardLayout title={t('manageObjectives.title.full')} callbackFromParent={this.myCallback}>
                    <div className={classes.root} style={{padding: 40}}>
                        <h2>{t('manageObjectives.noPermission')}</h2>
                    </div>
                </DashboardLayout>
            )
        }

        return (
            <DashboardLayout title={t('manageObjectives.title.configure')} callbackFromParent={this.myCallback}>
                {objectivesList ?
                    <div className={classes.root}>
                        <AppBar position="static" style={{ backgroundColor: '#333333'}}>
                            <Tabs value={value} onChange={this.handleChange} variant="scrollable">
                                <Tab label={t('manageObjectives.tabs.myObjectives')} />
                                {displayHours ? <Tab label={t('manageObjectives.tabs.businessHours')} /> : null}
                                {displayWeighing ? <Tab label={t('manageObjectives.tabs.clientWeighing')} /> : null}
                                <Tab label={t('manageObjectives.tabs.apdex')} value={4} />
                                <Tab label={t('manageObjectives.tabs.tags')} value={5} />
                                <Tab label={t('manageObjectives.tabs.flashboard')} value={6} />
                                <Tab label={t('manageObjectives.tabs.registrosPlus')} value={7} />
                                {showFlindex ? (
                                    <Tab label={t('manageObjectives.tabs.flindex')} value={8} />
                                ) : null}
                            </Tabs>
                        </AppBar>
                        <div style={{padding: 20}}>
                            { 
                                value == 0 ? 
                                    <ListObjectives objectivesList={objectivesList}/>   
                                : value == 1 ?
                                    <BusinessHours/> 
                                : value == 2 ?
                                    <ClientWeighing/>
                                : value === 4 ?
                                    <Apdex objectivesList={objectivesList} defaultObjective={this.state.apdexSetObjectiveId} />
                                : value === 5 ?
                                    <Tags />
                                : value === 6 ?
                                    <Flashboard />
                                : value === 7 ?
                                    <FormRegistrosPlus defaultObjective={this.props?.location?.query?.objetivoId} />
                                : value === 8 && showFlindex ?
                                    <Flindex defaultObjective={this.props?.location?.query?.objetivoId} />
                                : null
                            }
                        </div>
                    </div>
                :null}
            </DashboardLayout>
        );
    }
}

ManageObjectives.propTypes = {
    classes: PropTypes.object.isRequired
};

export default withTranslation()(withStyles(styles)(ManageObjectives));
